import * as React from "react";
import {
  MessageBar,
  MessageBarBody,
  MessageBarTitle,
  MessageBarActions,
  Button,
} from "@fluentui/react-components";
import { DismissRegular } from "@fluentui/react-icons";

export interface ErrorBannerProps {
  title?: string;
  message: string;
  onDismiss?: () => void;
}

const ErrorBanner: React.FC<ErrorBannerProps> = ({ title, message, onDismiss }) => {
  return (
    <MessageBar intent="error">
      <MessageBarBody>
        {title && <MessageBarTitle>{title}</MessageBarTitle>}
        {message}
      </MessageBarBody>
      {onDismiss && (
        <MessageBarActions>
          <Button
            appearance="transparent"
            icon={<DismissRegular />}
            onClick={onDismiss}
            aria-label="Dismiss"
          />
        </MessageBarActions>
      )}
    </MessageBar>
  );
};

export default ErrorBanner;
